import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 审核承诺书
export const auditCommitmentAduitRecord = params => {
    return reqGet("get", "/app-yijiu-backstage/auditCommitmentAduitRecord", params);
};

//查询承诺书审核列表
export const getCommitmentAduitRecordList = params => {
    return reqGet("get", "/app-yijiu-backstage/getCommitmentAduitRecordList", params);
};


// WEBPACK FOOTER //
// ./src/api/manage/aduit.js